<div data-test="confirmation-dialog" class="confirmation-dialog">
  <div class="dialog-title">
    <p>
      <span>{{ "campaign.filter.save-title" | translate }}</span>
    </p>
  </div>
  <div class="dialog-content" data-test="content-text">
    <mat-form-field appearance="outline">
      <mat-label>Filter name</mat-label>
      <input [(ngModel)]="name" required minlength="1" matInput placeholder="" value="{{ campaignFilterRequest?.name }}" #nameInput="ngModel" />
      @if (nameInput.invalid && nameInput.touched) {
        <mat-error>Filter name is required</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="actions-row">
    <button data-test="no-btn" mat-stroked-button (click)="clickCancel()" class="secondary-button cancel-button">{{ "generic.cancel" | translate }}</button>
    <button [disabled]="nameInput.invalid" data-test="yes-btn" mat-stroked-button (click)="clickSave()" class="primary-button proceed-button">
      @if (campaignFilterRequest?.id === null || campaignFilterRequest?.id === undefined) {
        {{ "generic.save" | translate }}
      } @else {
        {{ "generic.update" | translate }}
      }
    </button>
  </div>
</div>
